// removed by extract-text-webpack-plugin
module.exports = {"box":"_1swm4crn2Cy1xLxAwo2LJ5","boxTitle":"_1Ne2PeSa-GVIZY5VDHBBg8","boxSubtitle":"_-0YxYGsUSCWrP8cxamf6Z","boxBar":"_3fi4mnRtxKE_EfbDMIIzfD","content":"_3HXwOp4UnXR0zQu63O0y6E","listing":"_1qQ4ifwZFYMW_oQbM5e4kf","listingHeader":"_20qJdQRrNZMkYPJya_C_cq","listingContent":"iPmxZhruqxWsXY2_KKaBV","boxInfo":"_3oJt835_9hsr38KVcHMWF0","elementsList":"VSZfrc205zMQmoMRHLEa3","createLevelButton":"kj7d72XfBIrfwrSt55-c5","schoolLevelListItem":"hlwDhqImhk-pyAsAzVuhz"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Synchronization/Synchronization.scss
// module id = 976
// module chunks = 0